// React
import { useState, useEffect } from "react";

// MUI - Componentes
import {
  Box,
  Modal,
  InputBase,
  IconButton,
} from "@mui/material";

// MUI - Iconos
import SearchIcon from "@mui/icons-material/Search";

// MUI - Tema y colores
import { useTheme } from "@mui/material/styles";

// DataGrid
import { DataGrid } from "@mui/x-data-grid";

// Tu tema de colores (tokens)
import { tokens } from "../../theme"; // ajusta la ruta según tu proyecto

// Tu función de API
import { getUniformes } from "../../services/uniformes.services";
import { getDatosEmpresas } from "../../services/empresas.services";
import { getApiBaseUrl, getApiImagen } from "../../utils/getApiBaseUrl";

const ModalUniformes = ({ open, onClose, onSelectUniforme }) => {
  const [uniformes, setUniformes] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [searchValue, setSearchValue] = useState("");
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);

  const columns = [
    { field: "id", headerName: "ID", flex: 0.5 },
    {
      field: "descripcion",
      headerName: "Descripción",
      flex: 1,
      cellClassName: "name-column--cell",
    },
    { field: "talla", headerName: "Talla", flex: 0.5 },
    { field: "nombre_empresa", headerName: "Empresa", flex: 1 },
     {
      field: "img",
      headerName: "Imagen",
      flex: 0.6,
      headerAlign: "left",
      align: "left",
      renderCell: (params) => (
        <img
          src={`${ getApiImagen()}${params.value}`}
          alt="Uniforme"
          style={{ width: "150px", height: "100px", objectFit: "cover" }}
        />
      ),
    },

  ];

  useEffect(() => {
    const fetchUniformes = async () => {
      try {
        const response = await getUniformes();
        setUniformes(response);
        setFilteredData(response);
      } catch (error) {
        console.error("Error al obtener uniformes:", error);
      }
    };
    fetchUniformes();
  }, []);

  useEffect(() => {
  const fetchData = async () => {
    const [uniformesRes, empresasRes] = await Promise.all([
      getUniformes(),
      getDatosEmpresas()
    ]);

    const empresasMap = {};
    empresasRes.forEach(e => { empresasMap[e.id] = e.nombre; });

    const uniformesConNombre = uniformesRes.map(u => ({
      ...u,
      nombre_empresa: empresasMap[u.cod_empresa] || u.cod_empresa
    }));

    setUniformes(uniformesConNombre);
    setFilteredData(uniformesConNombre);
  };
  fetchData();
}, []);


  const handleSearchChange = (event) => {
    setSearchValue(event.target.value);
    const filtered = uniformes.filter(
      (u) =>
        u.descripcion.toLowerCase().includes(event.target.value.toLowerCase()) ||
        u.talla.toLowerCase().includes(event.target.value.toLowerCase()) ||
        u.nombre_empresa?.toLowerCase().includes(event.target.value.toLowerCase())
    );
    setFilteredData(filtered);
  };

  const handleRowClick = (params) => {
    onSelectUniforme(params.row);
    onClose();
  };

  return (
    <Modal
      open={open}
      onClose={onClose}
      aria-labelledby="modal-uniforme-title"
      style={{ display: "flex", alignItems: "center", justifyContent: "center" }}
      BackdropProps={{
        style: { backgroundColor: "rgba(0, 0, 0, 0.5)" },
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          backgroundColor: colors.primary[600],
          paddingLeft: "10px",
          paddingTop: "5px",
          paddingRight: "10px",
          paddingBottom: "10px !important",
          zIndex: 1500,
        }}
      >
        <Box m="0px">
          <Box display="flex" justifyContent="space-between" p={2}>
            <h1 id="modal-uniforme-title">Buscar Uniforme</h1>
            <Box
              display="flex"
              backgroundColor={colors.primary[400]}
              borderRadius="3px"
              height="40%"
              width="40%"
              marginTop="3%"
            >
              <InputBase
                sx={{ ml: 2, flex: 1 }}
                placeholder="Buscar"
                value={searchValue}
                onChange={handleSearchChange}
              />
              <IconButton type="button" sx={{ p: 1 }}>
                <SearchIcon />
              </IconButton>
            </Box>
          </Box>
          <Box
            m="10px 0"
            height="70vh"
            width="80vh"
            sx={{
              "& .MuiDataGrid-root": { border: "none" },
              "& .MuiDataGrid-cell": { borderBottom: "none" },
              "& .name-column--cell": { color: colors.greenAccent[300] },
              "& .MuiDataGrid-columnHeaders": {
                backgroundColor: colors.blueAccent[900],
                borderBottom: "none",
              },
              "& .MuiDataGrid-virtualScroller": {
                backgroundColor: colors.primary[400],
              },
              "& .MuiDataGrid-footerContainer": {
                borderTop: "none",
                backgroundColor: colors.blueAccent[900],
              },
              "& .MuiCheckbox-root": {
                color: `${colors.greenAccent[200]} !important`,
              },
            }}
          >
            <DataGrid
              rows={filteredData}
              columns={columns}
              onRowClick={handleRowClick}
               rowHeight={60} 
            />
          </Box>
        </Box>
      </Box>
    </Modal>
  );
};

export default ModalUniformes;